<template>
    <div>
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item> 计划任务书及相关文件 </el-breadcrumb-item>
            <el-breadcrumb-item>文件审核</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <!-- 搜索框 新增按钮-->
            <el-row class="row-search">
                <el-col class="el-col-user-add">
                    <el-input class="user-search" clearable placeholder="请输申报书信息（用空格分隔），支持模糊搜索" v-model="query">
                        <el-button slot="append" icon="el-icon-search" @click.prevent="queryProjectInfo()"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            <!-- 申报书列表 -->
            <el-table :data="projectInfo" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="leader_name" label="作者" width="100"></el-table-column>
                <el-table-column prop="new_name" label="名称" width="300"></el-table-column>
                <el-table-column prop="category" label="类别" width="280">
                    <!-- <template slot-scope="scope">
              <div>{{scope.row.category}}</div>
            </template> -->
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                            @click="showFile(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-card v-show="fileVisible">
            <div class="div-file">
                <!-- 文件列表 -->
                <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column prop="name" label="文件名" width="300"></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.create_time | fmtdate }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                                @click="getPdfCode(scope.row)"></el-button>
                            <el-button size="mini" :plain="true" type="danger" icon="el-icon-download" circle
                                @click="downloadFile(scope.row)">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-button class="button-commit" type="primary" style="margin-top:20px;"
                @click="buttonCommit">审核通过</el-button>
        </el-card>

        <!-- pdf查看 -->
        <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
            <div class="onlineHelp cg-box">
                <div class="tools">
                    <el-button type="mini" @click="zoomIn">放大</el-button>
                    <el-button type="mini" @click="zoomOut">缩小</el-button>
                </div>
                <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
            </div>
        </el-dialog>

    </div>
</template>

<script>
//下载
import fileDownload from 'js-file-download'
// pdf预览
import pdf from 'vue-pdf'

export default {
    components: {
        pdf
    },
    data() {
        return {
            //pdf显示
            pdfSrc: '', // PDF 文件的 URL
            pdfVisible: false, // 控制 PDF 弹窗显示
            iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整

            userid: '',
            username: '',
            query: '', //查询条件
            projectInfo: [],
            projectInfoSelected: {},
            fileVisible: false,
            fileList: [],
            fileListTemplate: [{
                name: '（模板）保密及权属协议书.docx',
                path: './static/（模板）保密及权属协议书.docx'
            },
            {
                name: '（模板）计划任务书.docx',
                path: './static/指南文件/（模板）计划任务书.docx.doc'
            },
            ]
        }
    },

    created() {
        this.userid = localStorage.getItem("userid")
        this.username = localStorage.getItem("username")
        this.getProjectInfo()
    },

    methods: {

        // 获取课题信息
        async getProjectInfo() {
            const res = await this.axios.get(`/projectInfo/?status=6`)
            if (res.status === 200) {
                this.projectInfo = res.data.results
            } else {
                this.$message.warning("错误")
            }
        },

        // 查询课题信息
        async queryProjectInfo() {
            const res = await this.axios.get(`/projectInfo/?status=6&search=${this.query}`)
            if (res.status === 200) {
                this.projectInfo = res.data.results
            } else {
                this.$message.warning("错误")
            }
        },

        // 显示文件card
        showFile(item) {
            this.fileVisible = true
            this.projectInfoSelected = item
            this.getFileList(item.pid + '/保密协议及计划任务书')
        },

        // 上传，编辑申报书，pid存在
        uploadFileEdit(e) {
            if (e.target.files[0].name.slice(-3) != 'pdf') {
                return this.$message.error('请上传pdf格式的文件！')
            }
            let formData = new FormData();
            // 调用后台上传接口，pid为具体路径，要加一层，防止用户查询到课题文件，误操作删除
            let pid = this.projectInfoSelected.pid + '/保密协议及计划任务书'
            let data = JSON.stringify({
                pid: pid
            })
            formData.append('file', e.target.files[0]);
            formData.append('data', data); // 上传文件的同时， 也可以上传其他数据
            let url = `/uploadFile/`;
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            this.axios.post(url, formData, config).then((response) => {
                this.getFileList(pid)
            })
        },

        // 获取附件列表
        async getFileList(pid) {
            const res = await this.axios.get(`/fileList/?pid=${pid}`)
            if (res.status === 200) {
                this.fileList = res.data.results
            } else {
                this.$message.warning("获取文件列表错误")
            }
        },

        // 删除文件
        async deleteFile(item) {
            let res = await this.axios.delete('/fileList/' + item.id + '/')
            if (res.status === 204) {
                this.getFileList(item.pid)
            }
            let data = {
                path: item.path
            }
            let resDelete = await this.axios.post('/deleteFile/', data)
            // console.log(resDelete)
        },

        // 下载文件
        downloadFile(item) {
            // console.log('下载：', item)
            // 注意：path里带有文件名
            let url = `/downloadFile/?path=${item.path}&name=${item.name}`
            let params = {
                path: item.path,
                name: item.name
            }
            this.axios.post(url, params, {
                responseType: 'arraybuffer'
            }).then(res => {
                fileDownload(res.data, item.name)
            })
        },


        // pdf预览
        // 获取 PDF 文件
        getPdfCode(item) {
            this.pdfVisible = true;  // 显示弹窗
            let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
            let params = {
                path: item.path,
                name: item.name
            };

            this.axios({
                method: 'post',
                url: url,
                data: params,
                responseType: 'blob' // 设置响应的数据类型为 Blob
            }).then(response => {
                // 检查是否为 PDF 文件
                const file = response.data;
                const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
                this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
            }).catch(error => {
                console.error("加载 PDF 文件失败:", error);
            });
        },

        // 将 Blob 转换为 URL
        createPdfObjectURL(file) {
            return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
        },
        // 放大 PDF
        zoomIn() {
            let currentHeight = parseInt(this.iframeHeight);
            this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
        },
        // 缩小 PDF
        zoomOut() {
            let currentHeight = parseInt(this.iframeHeight);
            this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
        },


        //   审核通过，待中期评审
        async buttonCommit() {
            let data = this.projectInfoSelected

            // 删除分配表
            let resGet = await this.axios.get('/projectDistribute/?pid=' + data.pid)
            if (resGet.status == 200) {
                let dataGet = resGet.data.results
                for (let k = 0; k < dataGet.length; k++) {
                    let resDel = await this.axios.delete('/projectDistribute/' + dataGet[k].id)
                    if (resDel.status != 204) {
                        this.$message.warning('删除原数据失败，请稍后再试！')
                    }
                }
            } else {
                this.$message.warning('获取数据失败，请稍后再试！')
            }

            // 修改课题表状态
            data.status = 8
            try {
                let resPut = await this.axios.put(`/projectInfo/${data.id}/`, data)
            } catch (error) {
                return this.$message.error(error)
            }
            setTimeout(() => {
                location.reload()
            }, 500)
        }
    },
}

</script>

<style lang="less">
.el-card {
    margin-top: 15px;
}

.header-edit {
    font-size: 18px;
    text-align: left;
    margin-bottom: 10px;
}

.el-col-user-add {
    display: flex;
}

.user-search {
    width: 420px;
    margin-right: 10px;
}

.div-upload {
    width: 500px;
    padding-top: 10px;
}

.div-add {
    margin-top: 20px;
    display: flex;
    justify-content: end;
}

.div-file {
    margin-top: 15px;

    .div-file-template {
        margin-bottom: 10px;
    }

    .div-upload {
        height: 47px;

        .input-upload {
            width: 101px;
            height: 33px;
            position: absolute;
            z-index: 1;
            opacity: 0;
        }

        .button-upload {
            position: absolute;
        }

        .button-upload:hover {
            cursor: pointer;
        }
    }
}

.el-input {
    width: 200px;
    margin-right: 80px;
}

.button-commit {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/signAgreement/AgreementAdminView.vue